/**
 * 搜索树中的模糊搜索
 */
import React from 'react';
import {message, Select} from 'antd';
const Option = Select.Option;
import {WWUtils,WWMethods} from "@/tools"
export default class MyAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionData: [],
            selectShow: 'none',
            ATClassName: this.props.ATClassName || 'AT_MyAutoComplete'
        };
        this.onSelect = this.onSelect.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getAutoCompleteResult = this.getAutoCompleteResult.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.setValue = this.setValue.bind(this);
    }

    componentDidMount() {

    }

    onSelect(value, option) {
        let other = option.props.other;
        if (this.props.sendAccountId) {
            this.props.sendAccountId(other.organizationId, other.value);
        }
        if(this.props.selectName){
            this.props.selectName(other.organizationId,other.value);
        }
        if (this.props.setAutoValue) {
            this.props.setAutoValue(other.value);
        }
        this.setState({
            value: other.value,
            selectShow:'none',
        }, () => {
            this.getAllParentAccount(other.organizationId);
        })
    }

    getAllParentAccount(organizationId) {
        let url = `${WWMethods.getApiUrl("allParents",this.props.platform)}${organizationId}`;
        let that = this;
        WWUtils.fetch(url,'GET',(data)=>{
            if (data && data.resultStatusBean || data ) {
                if (data.resultStatusBean && data.resultStatusBean.code === 0 || data && data.code === 0) {
                    if (data.data instanceof Array) {
                        let expandedKeys = [];
                        data.data.map(function (item) {
                            expandedKeys.push(String(item.organizationId));
                        });
                        that.props.positionCustomerNode(expandedKeys, String(organizationId),0);

                    }
                }else if(data.resultBean && data.resultBean.code === 40010 || data.code === 40010){
                    message.error(data.message || data.resultBean.result)
                }
            }
        })
    }
    onChange(value) {
        if (this.props.showTree) {
            this.props.showTree('inline-block')
        }
        if(value.length>20){
            value = value.substr(0,20);
        }
        this.setState({
            value: value
        });
        if (WWUtils.isNull(value)) {
            this.setState({
                selectShow: 'none'
            });
            return;
        }
        let len = 0
        for (let i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) > 127 || value.charCodeAt(i) == 94) {
                len += 2;
            } else {
                len++;
            }
        }
        if (len > 2) {
            this.getAutoCompleteResult(value)
        }
    }

    getAutoCompleteResult(value) {
        let url = ``;
        if (this.props.searchUrl) {//搜索结果5条
            url = this.props.searchUrl + value
        }
        if (this.props.rootAccountId) {//自定义围栏，组合行政区域围栏搜索
            url += '&parentId=' + this.props.rootAccountId
        }

        WWUtils.fetch(url,'GET',(data)=>{
            if(data &&  data.resultStatusBean && data.resultStatusBean.code === 0 || data && data.code === 0){
                this.setState({
                    optionData: data.data,
                    selectShow: (data.data && data.data.length > 0) ? 'block' : 'none'
                })
            }else if(data && data.resultStatusBean && data.resultStatusBean.code === 40010 || data && data.code === 40010){
                message.error(data.message || data.resultStatusBean.result)
            }
        },(message)=>{console.log(message)});
    }

    onFocus() {
        if (this.props.showTree) {
            this.props.showTree('inline-block')
        }
    }

    onBlur() {
        this.setState({
            selectShow: 'none'
        });
        if (this.props.setInputChangeF) {
            this.props.setInputChangeF(true)
        }
        if (this.props.setAutoValue) {
            this.props.setAutoValue(this.state.value);
        }
    }

    setValue(data) {
        this.setState({
            value: data,
        })
    }

    render() {
        const {selectShow, optionData,value, ATClassName} = this.state;
        //console.log(optionData)
        //客户搜索
        const option = optionData.map(function (item, index) {
            let content = item.name;
            let parentName=item.parentName;
            let value = item.name;
            return <Option className={ATClassName + '_option'} key={item.organizationId} style={{display:selectShow}}
                           other={{
                               organizationId: item.organizationId,
                               value: item.name,
                           }}
            ><span className="search_item" title={`${content}(${parentName})`}>{content}  ({parentName})</span></Option>
        });
        const {width,parentClass} = this.props;
        let that = this;
        return (
            <div className={"customer_select"}  onMouseEnter={()=>{
               if(this.props.InSelectOptions){
                   this.props.InSelectOptions(true)
               }
            }} onMouseLeave={()=>{
                if(this.props.InSelectOptions){
                    this.props.InSelectOptions(false)
                }
            }}>
                <Select
                    mode="combobox"
                    placeholder={Strings["prop.common.orgName"] || "门店名称"}
                    style={{width: width ? width : 250, margin: this.props.margins?this.props.margins:"5px auto",
                        display:"block",paddingTop:this.props.paddingTop?this.props.paddingTop:"0px",
                        paddingBottom:this.props.paddingBottom?this.props.paddingBottom:"0px"
                    }}
                    allowClear={this.props.disableSearch?!this.props.disableSearch:true}
                    notFoundContent={Strings.nodata || "没有符合条件的信息"}
                    defaultActiveFirstOption={false}
                    dropdownMatchSelectWidth={false}
                    selectShow={{display:selectShow}}
                    showArrow={false}
                    filterOption={false}
                    showSearch={this.props.disableSearch?!this.props.disableSearch:true}
                    onSelect={that.onSelect}
                    onSearch={this.props.disableSearch?()=>{return;}:that.onChange}
                    onBlur={that.onBlur}
                    onFocus={that.onFocus}
                    value={value}
                    disabled={this.props.disabled}
                    dropdownClassName={"select_options_"+parentClass}
                    id={ATClassName + '_select'}
                    className={this.props.disableSearch?"customer_select_auto":"customer_select "}
                    onClear={()=>{this.setValue("")}}
                >
                    {option}
                </Select>
            </div>
        )
    }
}
